import { Component, Input, Output, EventEmitter, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Helpers } from '../../../helpers';
import { JsonConvert } from 'json2typescript';
import { Asset } from '../../../_models/tenant/asset/asset';
import { GenericHandlerService } from '../../../_services/generic-handler.service';
import { Utilities } from '../../../_classes/utilities';

declare const toastr;
declare const $;

@Component({
    standalone: false,
    selector: 'app-tenant-asset',
    templateUrl: './tenant-asset.component.html'
})
export class TenantAssetComponent implements OnInit {
    @ViewChild('fileInput') fileInput: ElementRef;
    // -- Model
    @Input() model: string = "";
    @Output() modelChange: EventEmitter<string> = new EventEmitter<string>();
    // -------
    @Input() label = "Image";
    @Input() placeholder = "Add image";
    @Input() url = "";

    assets: Asset[] = [];
    private currentId: string = "";
    selectedFile: File | null = null;

    asset_modal_id: string = `${Utilities.generateRandomString(6)}_asset_modal`;
    delete_modal_id: string = `${Utilities.generateRandomString(6)}_delete_modal`;
    preview_modal_id: string = `${Utilities.generateRandomString(6)}_delete_modal`;

    constructor(private _generic: GenericHandlerService) {

    }

    ngOnInit(): void {
        if (!this.url) {
            console.error('Missing URL parameter');
            return;
        } else {
            this.url = `${this.url}/assets`
        }
    }

    modelChanged() {
        this.modelChange.emit(this.model); // Emette il nuovo valore
    }

    getData(openModal: boolean = true) {
        this.assets = [];
        Helpers.setLoading(true);

        /** MOCKED DATA */
        /*         setTimeout(() => {
                    const response = [
                        {
                            "id": "asset-001",
                            "name": "Logo Header",
                            "url": "https://dummyimage.com/600x200/000/fff&text=Header+Logo",
                            "width": 600,
                            "height": 200
                        },
                        {
                            "id": "asset-002",
                            "name": "Footer Image",
                            "url": "https://dummyimage.com/1200x150/333/fff&text=Footer+Image",
                            "width": 1200,
                            "height": 150
                        },
                        {
                            "id": "asset-003",
                            "name": "Background Banner",
                            "url": "https://dummyimage.com/1920x400/0066cc/ffffff&text=Banner",
                            "width": 1920,
                            "height": 400
                        },
                        {
                            "id": "asset-004",
                            "name": "Promo Tile 1",
                            "url": "https://dummyimage.com/300x300/ff4444/ffffff&text=Promo+1",
                            "width": 300,
                            "height": 300
                        },
                        {
                            "id": "asset-005",
                            "name": "Promo Tile 2",
                            "url": "https://dummyimage.com/300x300/44ff44/ffffff&text=Promo+2",
                            "width": 300,
                            "height": 300
                        },
                        {
                            "id": "asset-006",
                            "name": "Promo Tile 3",
                            "url": "https://dummyimage.com/300x300/4444ff/ffffff&text=Promo+3",
                            "width": 300,
                            "height": 300
                        },
                        {
                            "id": "asset-007",
                            "name": "Profile Placeholder",
                            "url": "https://dummyimage.com/150x150/cccccc/000000&text=Profile",
                            "width": 150,
                            "height": 150
                        },
                        {
                            "id": "asset-008",
                            "name": "Thumbnail 1",
                            "url": "https://dummyimage.com/100x100/999/fff&text=Thumb+1",
                            "width": 100,
                            "height": 100
                        },
                        {
                            "id": "asset-009",
                            "name": "Thumbnail 2",
                            "url": "https://dummyimage.com/100x100/666/fff&text=Thumb+2",
                            "width": 100,
                            "height": 100
                        },
                        {
                            "id": "asset-010",
                            "name": "Thumbnail 3",
                            "url": "https://dummyimage.com/100x100/333/fff&text=Thumb+3",
                            "width": 100,
                            "height": 100
                        },
                        {
                            "id": "asset-011",
                            "name": "Gallery Image 1",
                            "url": "https://dummyimage.com/800x600/f90/ffffff&text=Gallery+1",
                            "width": 800,
                            "height": 600
                        },
                        {
                            "id": "asset-012",
                            "name": "Gallery Image 2",
                            "url": "https://dummyimage.com/800x600/0c0/ffffff&text=Gallery+2",
                            "width": 800,
                            "height": 600
                        },
                        {
                            "id": "asset-013",
                            "name": "Gallery Image 3",
                            "url": "https://dummyimage.com/800x600/09f/ffffff&text=Gallery+3",
                            "width": 800,
                            "height": 600
                        },
                        {
                            "id": "asset-014",
                            "name": "Banner Small",
                            "url": "https://dummyimage.com/1024x150/990099/ffffff&text=Banner+Small",
                            "width": 1024,
                            "height": 150
                        },
                        {
                            "id": "asset-015",
                            "name": "Logo Compact",
                            "url": "https://dummyimage.com/200x100/000000/ffffff&text=Compact+Logo",
                            "width": 200,
                            "height": 100
                        },
                        {
                            "id": "asset-016",
                            "name": "Map Marker",
                            "url": "https://dummyimage.com/64x64/ff0000/ffffff&text=M",
                            "width": 64,
                            "height": 64
                        },
                        {
                            "id": "asset-017",
                            "name": "Notification Icon",
                            "url": "https://dummyimage.com/32x32/FFA500/000000&text=N",
                            "width": 32,
                            "height": 32
                        },
                        {
                            "id": "asset-018",
                            "name": "Help Icon",
                            "url": "https://dummyimage.com/32x32/00CED1/000000&text=H",
                            "width": 32,
                            "height": 32
                        },
                        {
                            "id": "asset-019",
                            "name": "Demo Graphic",
                            "url": "https://dummyimage.com/640x480/cccccc/000000&text=Demo",
                            "width": 640,
                            "height": 480
                        },
                        {
                            "id": "asset-020",
                            "name": "App Splash",
                            "url": "https://dummyimage.com/1280x720/007acc/ffffff&text=Splash",
                            "width": 1280,
                            "height": 720
                        }
                    ];
                    const jsonConvert = new JsonConvert();
                    this.assets = jsonConvert.deserializeArray(response, Asset);
                    if (openModal) {
                        this.clearFile();
                        $(`#${this.asset_modal_id}`).modal('show');
                    }
                    Helpers.setLoading(false);
                }, 2000); */

        this._generic.getCall(`${this.url}`, this._generic.buildHeaders())
            .subscribe(data => {
                const response: any = data.response;
                if (response) {
                    const jsonConvert = new JsonConvert();
                    this.assets = jsonConvert.deserializeArray(response, Asset);
                }
                if (openModal) {
                    this.clearFile();
                    $(`#${this.asset_modal_id}`).modal('show');
                }
                Helpers.setLoading(false);
            }, error => {
                Helpers.setLoading(false);
                toastr.error('An error has occured, please try again later');
            });

    }

    clear() {
        this.model = "";
        this.modelChanged();
    }

    close() {
        $(`#${this.asset_modal_id}`).modal('hide');
        this.modelChanged();
    }

    useImage(id: string) {
        this.model = id;
        this.close();
    }

    deleteImage(id: string) {
        this.currentId = id;
        $(`#${this.delete_modal_id}`).modal('show');
    }

    deleteConfirm() {
        Helpers.setLoading(true);
        this._generic.deleteCall(`${this.url}/${this.currentId}`, this._generic.buildHeaders())
            .subscribe(
            () => {
                $(`#${this.delete_modal_id}`).modal('hide');
                toastr.success("Asset deleted succesfully");
                Helpers.setLoading(false);
                this.getData(false);
            },
            error => {
                Helpers.setLoading(false);
                console.error(error);
                (<any>toastr).error("Error deleting asset, please try again later");
            }
            );
    }

    onFileSelected(event: Event): void {
        const input = event.target as HTMLInputElement;

        if (input.files && input.files.length > 0) {
            this.selectedFile = input.files[0];
        }
    }

    uploadFile(): void {
        if (!this.selectedFile) return;
        Helpers.setLoading(true);

        const reader = new FileReader();

        reader.onload = () => {
            const arrayBuffer = reader.result as ArrayBuffer;
            const blob = new Blob([arrayBuffer], { type: 'application/octet-stream' });
            const headers = this._generic.buildHeaders(blob.type);

            this._generic.postImageCall(`${this.url}/${this.selectedFile.name}`, blob, headers)
                .subscribe(
                () => {
                    toastr.success("Asset added succesfully");
                    Helpers.setLoading(false);
                    this.getData(false);
                },
                error => {
                    Helpers.setLoading(false);
                    console.error(error);
                    (<any>toastr).error("Error added asset, please try again later");
                }
                );
        };

        reader.readAsArrayBuffer(this.selectedFile);
    }

    preview() {
        $(`#${this.preview_modal_id}`).modal('show');
    }

    closeModal(id: string) {
        $(`#${id}`).modal('hide');
    }

    clearFile(): void {
        this.selectedFile = null;
        this.fileInput.nativeElement.value = '';
    }
}